import React, { useEffect, useState } from 'react';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import {
  CellContent,
  CellContentConnectionStatus,
  CellText,
  HeaderContent,
  ListContainer,
  ListContent,
  ListHeader,
  RowContent,
  StyledArrowDown,
  StyledArrowUp,
} from './styles';
import { OrderByValue } from '../../constants/TitleOptions';
import {
  CONNECTION_STATUS,
  CONNECTION_STATUS_LABELS,
} from '../../constants/ConnectionStatus';
import Pagination from '../../../../components/Pagination';
import { CustomTooltip } from '../../../../components/CustomTooltip';
import { Icon } from '@mui/material';
import { formatDateTime } from '../../../../utils/parsers-formatters';
import { connect } from 'react-redux';
import { changeFilters, getNoteList } from '../../../../redux/note-connection';
import { ListFeedback } from '../ListFeedback/ index';

const ConnectionsTable = ({
  data,
  titleOptions,
  orderByFilter,
  currentPage,
  pageLimit,
  totalItems,
  paginationOptions,
  dispatch,
  hasError,
}) => {
  const [orderByState, setOrderByState] = useState(orderByFilter || []);

  const handleCopyText = value => {
    navigator.clipboard.writeText(value);
  };

  // const handleHeaderContent = sortValues => {
  // const { value, type } = sortValues;
  // dispatch(changeFilters({ sort: value, sortType: type }));
  // dispatch(getNoteList());
  // };

  const handleChangePage = page => {
    dispatch(changeFilters({ currentPage: page }));
    dispatch(getNoteList());
  };

  const handleChangePageLimit = limit => {
    dispatch(changeFilters({ currentPage: 1, pageLimit: limit }));
    dispatch(getNoteList());
  };

  useEffect(() => {
    setOrderByState(orderByFilter);
  }, [orderByFilter]);

  return (
    <>
      {data && data.length > 0 ? (
        <ListContainer>
          <ListHeader>
            {titleOptions.map((item, index) => {
              const orderByItem = orderByState?.find(
                o => o.attribute === item.attribute,
              );
              return (
                <HeaderContent
                  // onClick={() => item.canOrder && handleHeaderContent(item)}
                  canOrder={item.canOrder}
                  width={item.width}
                  key={`${item.text}-${index}`}
                >
                  {item.text}
                  {item.canOrder &&
                    (orderByItem &&
                    orderByItem.value === OrderByValue.descending ? (
                      <StyledArrowUp />
                    ) : (
                      <StyledArrowDown />
                    ))}
                </HeaderContent>
              );
            })}
          </ListHeader>
          <ListContent>
            {data.map((value, index) => {
              const isRefused =
                value.importationStatus === CONNECTION_STATUS.REFUSED;
              return (
                <RowContent key={`${value.identifier}-${index}`}>
                  <CellContent width={titleOptions[0].width}>
                    <CellText>
                      {value.accessKeyDocument}
                      <CustomTooltip text="Copiado!" fontSize={10} justClick>
                        <Icon
                          name="copy"
                          component={ContentCopyIcon}
                          onClick={() =>
                            handleCopyText(value.accessKeyDocument)
                          }
                          style={{ color: '#0000008A' }}
                        />
                      </CustomTooltip>
                    </CellText>
                  </CellContent>
                  <CellContent width={titleOptions[1].width}>
                    <CellText>
                      {value.documentNumber}
                      <CustomTooltip text="Copiado!" fontSize={10} justClick>
                        <Icon
                          name="copy"
                          component={ContentCopyIcon}
                          onClick={() => handleCopyText(value.documentNumber)}
                          style={{ color: '#0000008A' }}
                        />
                      </CustomTooltip>
                    </CellText>
                  </CellContent>
                  <CellContent width={titleOptions[2].width}>
                    <CellText>{value.userName}</CellText>
                  </CellContent>
                  <CellContent width={titleOptions[3].width}>
                    <CellText>{formatDateTime(value.timeStamp)}</CellText>
                  </CellContent>
                  <CellContent width={titleOptions[4].width}>
                    <CustomTooltip
                      text={isRefused ? value.errors : ''}
                      fontSize={14}
                    >
                      <CellContentConnectionStatus
                        connectionStatus={value.importationStatus}
                      >
                        {CONNECTION_STATUS_LABELS[value.importationStatus]}
                      </CellContentConnectionStatus>
                    </CustomTooltip>
                  </CellContent>
                </RowContent>
              );
            })}
          </ListContent>
          <Pagination
            options={paginationOptions}
            currentPage={currentPage}
            pageLimit={pageLimit}
            totalItems={totalItems}
            onChangePage={handleChangePage}
            onPageLimitChange={handleChangePageLimit}
            style={{
              width: '100%',
              borderTop: '1px solid rgba(0, 0, 0, 0.12)',
            }}
          />
        </ListContainer>
      ) : (
        <ListFeedback isError={hasError} />
      )}
    </>
  );
};

function mapStateToProps(state) {
  return {
    hasError: state.notesConnection.noteList.error !== '',
  };
}

export default connect(mapStateToProps)(ConnectionsTable);
